<template>
  <header class="top-bar">
    <button class="hamburger" aria-label="Menu" @click="$emit('toggle')">
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      >
        <line x1="3" y1="6" x2="21" y2="6" />
        <line x1="3" y1="12" x2="21" y2="12" />
        <line x1="3" y1="18" x2="21" y2="18" />
      </svg>
    </button>
    <div class="mobile-brand">
      <svg viewBox="0 0 24 24" width="22" height="22" fill="none">
        <ellipse
          cx="12"
          cy="6.5"
          rx="2.5"
          ry="5.5"
          fill="#c9956c"
          opacity="0.9"
        />
        <ellipse
          cx="12"
          cy="6.5"
          rx="2.5"
          ry="5.5"
          fill="#c9956c"
          opacity="0.88"
          transform="rotate(72 12 12)"
        />
        <ellipse
          cx="12"
          cy="6.5"
          rx="2.5"
          ry="5.5"
          fill="#c9956c"
          opacity="0.82"
          transform="rotate(144 12 12)"
        />
        <ellipse
          cx="12"
          cy="6.5"
          rx="2.5"
          ry="5.5"
          fill="#c9956c"
          opacity="0.88"
          transform="rotate(216 12 12)"
        />
        <ellipse
          cx="12"
          cy="6.5"
          rx="2.5"
          ry="5.5"
          fill="#c9956c"
          opacity="0.82"
          transform="rotate(288 12 12)"
        />
        <circle cx="12" cy="12" r="3.5" fill="#1f3530" />
        <circle cx="12" cy="12" r="1.8" fill="#c9956c" />
      </svg>
      <span>{{ companyName }}</span>
    </div>

    <!-- Indicador de alertas no mobile -->
    <router-link
      v-if="totalAlertas > 0"
      to="/estoque"
      class="topbar-alert"
      :title="`${totalAlertas} alerta${totalAlertas > 1 ? 's' : ''} de estoque`"
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        width="18"
        height="18"
      >
        <path
          d="M12 9v4M12 17h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
        />
      </svg>
      <span class="topbar-alert__count">{{ totalAlertas }}</span>
    </router-link>
  </header>
</template>

<script>
import produtosService from "@/services/produtos";

export default {
  name: "AppTopBar",
  emits: ["toggle"],
  data() {
    return { alertasEstoqueCount: 0 };
  },
  computed: {
    companyName() {
      return this.$store.getters.currentCompany?.nome || "ERP";
    },
    totalAlertas() {
      return this.alertasEstoqueCount;
    },
  },
  watch: {
    "$store.getters.currentCompany"() {
      this.carregarAlertas();
    },
  },
  async created() {
    await this.carregarAlertas();
  },
  methods: {
    async carregarAlertas() {
      if (
        !this.$store.getters.isAuthenticated ||
        !this.$store.getters.hasCompanySelected
      )
        return;
      try {
        const res = await produtosService.alertasEstoque();
        const d = res.data;
        this.alertasEstoqueCount =
          (d.produtos?.length || 0) +
          (d.materiais?.length || 0) +
          (d.variantes?.length || 0);
      } catch {
        this.alertasEstoqueCount = 0;
      }
    },
  },
};
</script>

<style scoped>
.top-bar {
  display: none;
  align-items: center;
  gap: 1rem;
  padding: 0.875rem 1.25rem;
  background: var(--c-surface);
  border-bottom: 1px solid var(--c-border-light);
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: var(--sh-xs);
}

.hamburger {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  color: var(--c-text);
  border-radius: var(--r-xs);
  transition: var(--tr);
  flex-shrink: 0;
}

.hamburger svg {
  width: 22px;
  height: 22px;
  display: block;
}

.hamburger:hover {
  background: var(--c-bg);
}

.mobile-brand {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: var(--font-brand);
  font-weight: 700;
  font-size: 1.125rem;
  color: var(--c-text);
}

.topbar-alert {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  background: #dc2626;
  color: #fff;
  border-radius: var(--r-full);
  padding: 0.2rem 0.5rem;
  text-decoration: none;
  flex-shrink: 0;
}

.topbar-alert__count {
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1;
}

@media (max-width: 1023px) {
  .top-bar {
    display: flex;
    padding-top: calc(0.875rem + env(safe-area-inset-top, 0px));
  }
}
</style>
